import React, { useEffect, useState } from 'react';

import AssetService from '../../../shared/services/AssetService';
import ChangeFile from '../../../shared/components/ChangeFile';
import Constants from '../../constants';
import MediaText from './MediaText';
import { ScreenCaptureComponent } from '../../models/LessonComponent';
import { useLessonComponentContext } from '../../models/LessonComponentContext';
import { useLessonContext } from '../../models/LessonContext';
import videoPlayerStyles from '../../styles/AudioVideoPlayer.module.css';

interface ScreenCaptureVideoProps {
  videoUrl: string;
  component?: ScreenCaptureComponent;
}
export const ScreenCaptureVideo = (props: ScreenCaptureVideoProps) => {
  const { mode } = useLessonContext();
  const { componentType } = useLessonComponentContext();
  const [isImage, setIsImage] = useState(false);
  const src = AssetService.getAssetUrl(props.videoUrl);
  useEffect(() => {
    setIsImage(false);
    const img = new Image();
    img.onload = () => setIsImage(true);
    img.src = src;
  }, [src]);

  return isImage ? (
    <div className={videoPlayerStyles.imagePlayerWrapper}>
      <img
        className={videoPlayerStyles.imagePlayer}
        src={src}
        alt="Screen capture"
      />
    </div>
  ) : (
    <div className={videoPlayerStyles.reactPlayerWrapper}>
      <video
        className={videoPlayerStyles.reactPlayer}
        controls
        controlsList="nodownload" //Hide 'Download' option in the video
        preload="auto"
        width="100%"
        height="100%"
        src={AssetService.getAssetUrl(props.videoUrl) || ''}
      />
      {mode === 'edit' &&
        !props.videoUrl &&
        componentType === 'screen_capture_comparison' && (
          <MediaText text={Constants.VideoText} invertColor />
        )}
      {mode === 'edit' && componentType === 'screen_capture' && (
        <ChangeFile
          component={props.component}
          assetkey={props.videoUrl}
          assetTypes={['video']}
        />
      )}
    </div>
  );
};
